module.exports = __webpack_public_path__ + "static/media/nissan-plus.fb591a07.svg";